// table tvKennarar has the field fFlagUmsokn with default 1 to display each teacher, if changed to 0 that teacher is not on the application form.


import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'


import { SelectInput } from "../components/SelectInput"
import { Clear } from "@mui/icons-material";

interface SelectInputOption {
  value: number;
  title?: string;
}
export interface SubjectFormProps {
  onRemove: (index: number) => void
  disableRemoveButton: boolean
  teacherOptions: SelectInputOption[]
  teacherFlag: number | 0
  placeOptions: SelectInputOption[]
  gradeOptions: SelectInputOption[]
  ratioOptions: SelectInputOption[]
  options: SelectInputOption[];
  index?: number
  label: string
  name: string
}



export const SubjectForm = (props: SubjectFormProps) => {
  const index = props.index ? props.index : 0

  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 3 }}>
            {
              !props.disableRemoveButton &&
              <IconButton
                size="small"
                disabled={props.disableRemoveButton}
                onClick={() => props.onRemove(index)}
                sx={{ pl: 0 }}
              >
                <Clear />
              </IconButton>
            }
            Námsgrein{` - ${index + 1}. val`}
            {/* {(index > 0) && <>{` ${index + 1}`}</>} */}

          </Typography>
          <Grid container spacing={1}>

            <Grid xs={12} sm={4} md={4}>
              <SelectInput name={`subjects[${index}].id`} label="Námsgrein" options={props.options} />
            </Grid>
            {props.ratioOptions.length > 0 &&
              <Grid xs={12} sm={2} md={2}>
                <SelectInput name={`subjects[${index}].rateid`} label="Hlutfall" options={props.ratioOptions} value={1} />
              </Grid>}
            {props.gradeOptions.length > 0 &&
              <Grid xs={12} sm={2} md={2}>
                <SelectInput name={`subjects[${index}].gradeid`} label="Áfangi" options={props.gradeOptions} />
              </Grid>}
            {props.teacherFlag > 0 && <Grid xs={12} sm={4} md={4}>
              <SelectInput name={`subjects[${index}].teacherid`} label="Ósk um kennara" options={props.teacherOptions} />
            </Grid>}
            {props.placeOptions.length > 0 && <Grid xs={12} sm={6} md={4}>
              <SelectInput name={`subjects[${index}].placeid`} label="Ósk um kennslustað" options={props.placeOptions} />
            </Grid>}

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )







}